import apiWorker from '../apiWorker'

const contact_submissions = {

    search:         (data)                  =>  apiWorker('post', `/api/v1/core/contact_submissions/search`, data),

}

export default contact_submissions;